import { ActionTypes, OptionTypes } from '../constants'

const initialOptions = {
    selected:{
        speedTypeId:'',
        houseTypeId:OptionTypes.HOUSE_NONE,
        paperSizeTypeId:'',
        foldingTypeId:'',
        printNumTypeId:'',
        // printNumTypeValue:'',
        paperQualityTypeId:'',
        colorTypeId:'',
        gapypeId:'',
        requestDesignTypeId:'',
        requestDesignTemplateId:'',
        requestMapTypeId:'',
    },
    errors:{},
    rules:{
        maxPostNum:0,
        restrictSpeedByArea:[],
        NormalHouseTypeByArea:null,
        AreaNote:[],
    },
    speedType:[],
    houseType:[],
    paperSizeType:[],
    foldingType:[],
    printNumType:[],
    paperQualityType:[],
    colorType:[],
    gapType:[],
    requestDesignType:[],
    requestDesignTemplate:[],
    requestMapType:[],
    areaNotes:[],
}


// Reducer
function optionsReducer( options = initialOptions, action) {
    switch (action.type) {
        case ActionTypes.GET_INITIAL_OPTIONS:
            return action.options;

        case ActionTypes.SELECT_OPTIONS:
            return {...options, selected:{...options.selected, ...action.selected}};

        case ActionTypes.UPDATE_OPTIONS:
            return {...options, ...action.options, selected:{...options.selected, ...action.options.selected}};

        case ActionTypes.ERROR_OPTIONS:
            let errors = ( 'errors' in options )? options.errors:{}
            errors[action.key] = action.msg
            return {...options, errors: {...errors} };

        case ActionTypes.SET_AREA_NOTE:
            return {...options, areaNotes:action.areaNotes };

        default:
            return options;
    }
}

export default optionsReducer


// WEBPACK FOOTER //
// ./src/reducers/options.js